
import {
  Vue, Component,
} from 'vue-property-decorator';
import EditLeadCustomerDialog from '@/components/EditLeadCustomerDialog.vue';
import LeadCustomerContent from '@/components/LeadCustomerContent.vue';
import PermissionsInfo from '@/components/PermissionsInfo.vue';
import { PermissionCode, User } from '@/types';

@Component({
  components: {
    EditLeadCustomerDialog,
    LeadCustomerContent,
    PermissionsInfo,
  },
})
export default class LeadCustomer extends Vue {
  editDialog = false

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions() {
    return this.$store.getters.currentUserPermissions;
  }

  get isSuperUser() {
    return this.user && this.user.isSuperUser;
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  get type() {
    if (!this.lead || 'tipoCliente' in this.lead === false) return null;
    return this.lead.tipoCliente;
  }

  get isPerson() {
    return this.type === 'person';
  }

  get isBusiness() {
    return this.type === 'business';
  }

  get typeLong() {
    if (this.isPerson) return 'Persona fisica';
    if (this.isBusiness) return 'Azienda';
    return null;
  }

  get isRequester() {
    return this.user && this.lead && this.user.id === this.lead.requesterId;
  }

  get isEditable() {
    if (this.isSuperUser) return true;

    return this.lead
      && 'status' in this.lead
      && (this.lead.status === 'open' || this.lead.status === 'new')
      && (this.isRequester
        || (this.lead.status === 'new' && this.hasPermission('leads.modify_on_new'))
        || (this.lead.status === 'open' && this.hasPermission('leads.customer.modify'))
      );
  }

  get indirizzo() {
    if (!this.lead) return null;

    let result = '';

    if (this.lead.indirizzo && this.lead.indirizzo !== 'hidden') {
      if (this.lead.toponimo) result += `${this.lead.toponimo} `;
      if (this.lead.indirizzo) result += `${this.lead.indirizzo} `;
      if (this.lead.civico) result += `${this.lead.civico} `;
      // if (this.lead.interno) result += `${this.lead.interno}`;
      result += '<br>';
    }
    if (this.lead.cap && this.lead.cap !== 'hidden') result += `${this.lead.cap} `;
    if (this.lead.citta) result += `${this.lead.citta} `;
    if (this.lead.provincia) result += `<span style="text-transform: uppercase;">(${this.lead.provincia})</span>`;

    return result;
  }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  onEdit() {
    this.editDialog = true;
  }
}
